
export type NameComponentValue = string | null;
